import { gql } from '@apollo/client';

export const ALL_FRAMEWORKS = gql`
  query getFrameworks {
    frameworks: getFrameworks {
      id
      name
      indicatorsOnly
      levels {
        id
        name
        level
        allowIndicators
      }
      defaults {
        id
        type
        number
        description
        level {
          id
        }
        parentResult {
          id
        }
      }
    }
  }
`;
